
import axios from '../../config/axiosConfig';
import { BANK_RECEIPT_RETURN_TRANSACTION_REQUEST, GET_BANK_RECEIPT_RETURN_TRANSACTIONS, BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_RETURN_TRANSACTIONS, GET_BANK_NAME_BANK_RECEIPT_RETURN_TRANSACTIONS } from '../types';

export const getBankReceiptReturnTransactions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
            axios.get('/bank-receipt-return-transaction/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANK_RECEIPT_RETURN_TRANSACTIONS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
        }
    };
};


export const getAllAccountIdWiseConsigneeBankReceiptReturnTransactions = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };

      return axios.get("/bank-receipt-return-transaction/get-account-id-wise-consignee", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_RETURN_TRANSACTIONS, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAllBankNameBankReceiptReturnTransactions = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };

      return axios.get("/bank-receipt-return-transaction/get-bank-names", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_NAME_BANK_RECEIPT_RETURN_TRANSACTIONS, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};
